import * as yup from "yup";

export const selectStudioFormSchema = yup
  .object({
    selectedStudioId: yup.number().required().defined(),
  })
  .required();

export type ISelectStudioFormModel = yup.InferType<
  typeof selectStudioFormSchema
>;

export const selectStudioFormDefaultValues: ISelectStudioFormModel = {
  selectedStudioId: 0,
};
